<div #dialog></div>

<mat-card style="margin: 10px;" class="mat-elevation-z1">
  <app-search-universal-basic (Search)="searchIncidents($event)" (Reload)="reload($event)"></app-search-universal-basic>
</mat-card>

<mat-card style="margin: 10px;" *ngIf="selectIncidents.length>0">
  <app-report-preview [incidents]="selectIncidents" [showDelete]="true" [isEditable]="true" (removeIncident)="RemoveSelectedForReport($event)"></app-report-preview>
  <hr>
  <button mat-stroked-button color="primary" ><mat-icon>add</mat-icon><span>CREATE REPORT with SELECTED INCIDENT<span *ngIf="selectIncidents.length>1">S</span></span></button>
</mat-card>

<mat-card style="margin: 10px;">
  <button mat-stroked-button (click)="openNewIncidentDialog()"><mat-icon>add</mat-icon> CREATE INCIDENT</button>
  <app-view-incidents-tbl [showAdd]="false" [Incidents]="dataSource" (SelectedEvent)="SelectedForReport($event)" (TriggerReload)="reload($event)"></app-view-incidents-tbl>

</mat-card>

